export default function ConfigReservation(vm) {
    this.create = function(params) {
        var url = '/config/reservation/create';

        return vm.post(url, params);
    };

    this.get = function() {
        var url = '/config/reservation/detail';

        return vm.get(url);
    };
}